import { render, staticRenderFns } from "./QuestionLink.vue?vue&type=template&id=5d42351c&"
import script from "./QuestionLink.vue?vue&type=script&lang=js&"
export * from "./QuestionLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports